import Row from "./Row";
import TaxAPI from "../../../../tax-api/TaxAPI";
import { useState } from "react";
import { DragDropContext } from "react-beautiful-dnd";
import styled from "styled-components";
import { motion } from "framer-motion";
import { useFirestore } from "react-redux-firebase";
import { colors } from "../../ContactDetail";
import { EyeSlash, Eye } from "phosphor-react";

const Container = styled.div`
  display: none;
  @media screen and (min-width: 900px) {
    font-size: 12px;
    position: relative;
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid grey;
    display: block;
  }
`;

const DatesContainer = styled.div`
  margin: 10px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  border: 1px solid lightgrey;
  padding: 10px 10px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  background: white;
  position: relative;
`;

const AreaTitle = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 5px;
  color: lightgrey;
  text-transform: uppercase;
  font-weight: 900;
  border-top: 1px solid lightgrey;
  border-left: 1px solid lightgrey;
  display: flex;
  align-items: center;
  cursor: pointer;
  &:hover {
    color: grey;
  }
`;

const AreaRemove = styled.div`
  margin-left: 10px;
`;

const Date = styled.div`
  margin: 5px 0;
  display: flex;
  width: 50%;
  padding: 0 5px;
  label {
    width: 40%;
  }
  input {
    width: 50%;
    padding: 5px;
    border: 1px solid var(--grey);
    border-radius: 3px !important;
  }
  align-items: center;
`;

const List = styled.div`
  border: 1px solid lightgrey;
  padding: 15px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  margin: 10px 0;
  background: white;
`;

const PSA = styled.div`
  border: 1px solid lightgrey;
  padding: 10px 10px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
`;
const PSATextArea = styled.div`
  textarea {
    border: none;
    border-radius: 1px !important;
    padding: 10px;
    height: 100px;
    width: 100%;
    border: 1px solid lightgrey;
    margin-bottom: 5px;
  }
`;

const DefaultButton = styled.div`
  background: white;
  padding: 10px;
  display: flex;
  align-items: center;
  color: #798b79;
  border: 1px solid #798b79;
  border-radius: 3px;
  cursor: pointer;
  width: max-content;
  &:hover {
    background: #798b79;
    color: white;
  }
`;

const Notes = styled.div`
  border: 1px solid lightgrey;
  padding: 10px 10px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  textarea {
    border: none;
    border-radius: 1px !important;
    padding: 10px;
    height: 100px;
    width: 100%;
    border: 1px solid lightgrey;
    margin-bottom: 5px;
  }
  margin: 10px 0;
`;

const Tax = styled.div`
  border: 1px solid lightgrey;
  padding: 10px 10px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  width: max-content;
  background: white;
  margin-right: 10px;
`;

const SmallBoxes = styled.div`
  display: flex;
  align-items: flex-end;
`;

const Delete = styled.div`
  border: 1px solid red;
  color: red;
  padding: 10px;
  height: max-content;
  border-radius: 3px;
  cursor: pointer;
  &:hover {
    color: white;
    background: red;
  }
`;

const Type = styled.div`
  min-height: 100%;
  padding: 0;
  width: max-content;
`;

const TypeSelect = styled.div`
  padding: 12px 5px;
  text-align: center;
  background: ${({ selected, color }) => (selected ? color : "white")};
  border: 1px solid ${({ color }) => color};
  color: ${({ selected, color }) => (!selected ? color : "white")};
  font-weight: 900;
  cursor: pointer;
  &:hover {
    transform: translateX(1em);
  }
`;

const DocumentForm = ({
  setStoredDocuments,
  storedDocuments,
  contact,
  doc,
  editDocument,
  addKit,
  addItem,
  color,
  prices,
}) => {
  console.log(doc);
  const deleteDocument = () => {
    let docs = [...storedDocuments];
    if (window.confirm("You sure you want to delete?")) {
      docs.splice(docs.indexOf(doc), 1);
      setStoredDocuments(docs);
      return firestore.delete(
        { collection: "client-documents", doc: doc.id },
        docs[docs.indexOf(doc)]
      );
    }
  };

  const [defaultPSA, setDefaultPSA] = useState(
    typeof contact.psaDefault === "undefined" ? "false" : contact.psaDefault
  );

  const firestore = useFirestore();

  const handleSetContactBool = (name, value, stateSet) => {
    editDocument(doc, name, !doc[name]);
  };

  const moveItem = (docs) => {
    setStoredDocuments(docs);
    return firestore.update(
      { collection: "client-documents", doc: doc.id },
      docs[docs.indexOf(doc)]
    );
  };

  const onDragEnd = (result) => {
    const { destination, source, draggableId } = result;

    if (!destination) {
      return;
    }

    if (
      (destination.droppableId =
        source.droppableId && destination.index === source.index)
    ) {
      return;
    }

    const kit = doc.kits.filter((kit) => kit.id === source.droppableId)[0];

    const newItemIds = Array.from(kit.items);

    newItemIds.splice(source.index, 1);
    const item = kit.items.filter(
      (item) => item.title + kit.items.indexOf(item) + kit.id === draggableId
    )[0];

    newItemIds.splice(destination.index, 0, item);

    const newKit = {
      ...kit,
      items: newItemIds,
    };

    const newState = [...storedDocuments];
    newState[newState.indexOf(doc)].kits[doc.kits.indexOf(kit)] = newKit;

    moveItem(newState);
  };

  return (
    <Container
      as={motion.div}
      initial={{ y: -25, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
      exit={{ y: -25, opacity: 0 }}
      layout
    >
      <DatesContainer>
        <Date>
          <label>Deposit Due</label>
          <input
            name="depositDue"
            defaultValue={doc.depositDue}
            onBlur={(e) => editDocument(doc, e.target.name, e.target.value)}
            autoComplete="off"
          />
        </Date>
        <Date>
          <label>50% Due Date</label>
          <input
            name="fiftyDue"
            defaultValue={doc.fiftyDue}
            onBlur={(e) => editDocument(doc, e.target.name, e.target.value)}
            autoComplete="off"
          />
        </Date>
        <Date>
          <label>Full Due Date</label>
          <input
            name="fullDue"
            defaultValue={doc.fullDue}
            onBlur={(e) => editDocument(doc, e.target.name, e.target.value)}
            autoComplete="off"
          />
        </Date>

        <Date>
          <label>Production Date</label>
          <input
            name="productionDate"
            defaultValue={doc.productionDate}
            onBlur={(e) => editDocument(doc, e.target.name, e.target.value)}
            autoComplete="off"
          />
        </Date>
        <Date>
          <label>Ship Date</label>
          <input
            name="shipDate"
            defaultValue={doc.shipDate}
            onBlur={(e) => editDocument(doc, e.target.name, e.target.value)}
            autoComplete="off"
          />
        </Date>
        <AreaTitle onClick={() => editDocument(doc, "showDates", !doc.showDates)}>
          Dates
          <AreaRemove>
            {doc.showDates ? (
              <Eye size={32} weight="fill" />
            ) : (
              <EyeSlash size={32} weight="fill" />
            )}
          </AreaRemove>
        </AreaTitle>
      </DatesContainer>

      <SmallBoxes>
        <Tax>
          <label>Sales Tax</label>
          <TaxAPI
            street={contact.deliveryStreetAddress}
            city={contact.deliveryCity}
            state={contact.deliveryRegion}
            zip={contact.deliveryZipCode}
            editDocument={editDocument}
            tax={doc.tax}
            doc={doc}
          />
        </Tax>
        <Type>
          <TypeSelect
            onClick={() => editDocument(doc, "type", "purchase agreement")}
            selected={doc.type === "purchase agreement"}
            color={colors["purchase agreement"]}
          >
            Purchase Agreement
          </TypeSelect>
          <TypeSelect
            onClick={() => editDocument(doc, "type", "final invoice")}
            selected={doc.type === "final invoice"}
            color={colors["final invoice"]}
          >
            Final Invoice
          </TypeSelect>
          <TypeSelect
            onClick={() => editDocument(doc, "type", "custom")}
            selected={doc.type === "custom"}
            color={colors["custom"]}
          >
            Custom
          </TypeSelect>
        </Type>
      </SmallBoxes>
      <List>
        <DragDropContext onDragEnd={onDragEnd}>
          {doc.kits.map((kit, i) => (
            <div key={kit.id}>
              <Row
                kit={kit}
                i={i}
                addItem={addItem}
                doc={doc}
                storedDocuments={storedDocuments}
                setStoredDocuments={setStoredDocuments}
                color={color}
                prices={prices}
              />
            </div>
          ))}
        </DragDropContext>
        <button id="add-yurt-button" onClick={() => addKit(doc)}>
          Add Kit
        </button>
      </List>
      <PSA>
        <PSATextArea>
          <label>PSA</label>
          <textarea
            name="psa"
            defaultValue={doc.psa}
            onChange={(e) => editDocument(doc, e.target.name, e.target.value)}
          />
        </PSATextArea>

        <DefaultButton
          onClick={() =>
            handleSetContactBool("psaDefault", defaultPSA, setDefaultPSA)
          }
        >
          {contact.psaDefault ? "Default Active" : "Set Default"}
        </DefaultButton>
      </PSA>

      <Notes>
        <label>Notes</label>
        <textarea
          name="notes"
          defaultValue={doc.notes}
          onChange={(e) => editDocument(doc, e.target.name, e.target.value)}
        />
      </Notes>
      <Delete onClick={() => deleteDocument()}>Delete Document</Delete>
    </Container>
  );
};

export default DocumentForm;
